// Used a separate file for bundling
import { IDashboardContext } from "../../../contexts/dashboard-context";
import { isPhotoEditingMenuSupported } from "../bottom-photo-editing/menu-info";
import { isPhotoFiltersPanelSupported } from "../photo-filters-panel/menu-info";
import { isPhotoSelectionPanelSupported } from "../photo-selection-panel/menu-info";
import { isPhotoTransformSupported } from "../photo-transform-panel/menu-info";

export function isDeletePhotoZoneSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	return eXpress.core.isPhotoZone(zone) && dashboard.canDeletePhotoZone(zone);
}

export function isClearPhotoZoneSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: IDashboardContext,
) {
	return (
		eXpress.core.isPhotoZone(zone) &&
		dashboard.canRemovePhotoFromZones(zone ? [zone] : undefined)
	);
}

function isAddPhotoZoneSupported(
	pageZone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	return dashboard.canAddPhotoZoneToPage(pageZone);
}

function isZoneDepthSupported(zone: eXpress.core.IZone | undefined) {
	return zone ? zone.canChangeTransform() : false;
}

export function isBottomPhotoMenuSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: IDashboardContext,
	page: eXpress.core.IPageZone | undefined | null,
) {
	return (
		// Don't show photo menu's if only maps are supported
		isPhotoSelectionPanelSupported(page) || // Replace button
		dashboard.canRemovePhotoFromZones(zone ? [zone] : undefined) || // Delete photo
		dashboard.canRotatePhoto(
			eXpress.core.isPhotoZone(zone) ? zone.getPhotoLook() : undefined,
		) || // Rotate photo
		isPhotoFiltersPanelSupported(zone, dashboard) || // Filter button
		isDeletePhotoZoneSupported(zone, dashboard) ||
		isClearPhotoZoneSupported(zone, dashboard) ||
		isPhotoEditingMenuSupported(zone, dashboard) ||
		isAddPhotoZoneSupported(page, dashboard) ||
		isPhotoTransformSupported(zone, dashboard) ||
		isZoneDepthSupported(zone)
	);
}
